import React, { memo } from 'react'
import { definitions } from 'generated/apiTypes'
import { DNLayersToMapData } from './DNLayersToMapData'
import { DNLayer } from './DNLayer'

export const DNLayersComponent = memo(function DNLayersComponent({
  layers,
}: {
  layers: definitions['VectorBasemapResults']
}) {
  return (
    <>
      {DNLayersToMapData(layers)?.map((item) => (
        <DNLayer key={item.id} id={item.id} layer={item.layer} source={item.source} />
      ))}
    </>
  )
})
